import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ManutencaoCTEService } from 'src/app/services/gestao-de-cte/gestao-de-cte.service';
import { sugestaoLotesResponse } from '../../gestao-de-cte.model';

@Component({
  selector: 'app-modal-confirmacao-lote',
  templateUrl: './modal-confirmacao-lote.component.html',
  styleUrls: ['./modal-confirmacao-lote.component.scss']
})
export class ModalConfirmacaoLoteComponent implements OnInit {
  isLoading;

  textoCancelar = "Cancelar";
  textoOk = "Confirmar";
  titulo = "Escolha sua opção para a geração de lotes:";

  infoCTE;
  usuario;
  totalCte;

  public selectForm = new FormGroup({
    tipoLote: new FormControl('')
  });

  get tipoLote() { return this.selectForm.get('tipoLote').value; }

  public displayedColumns: string[] = ['lotes', 'freteTotal'];
  public gridLoteGeral: MatTableDataSource<any> = new MatTableDataSource<any>();

  public displayedColumnsClient: string[] = ['lotes', 'freteTotal'];
  public gridLotesPorCliente: MatTableDataSource<any> = new MatTableDataSource<any>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: MatDialogRef<ModalConfirmacaoLoteComponent>,
    public service: ManutencaoCTEService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) {
    data ? this.infoCTE = data : this.infoCTE = null;
  }

  confirm() {

    let obj =
    {
      "identificador": this.infoCTE,
      "porCliente": this.tipoLote
    };
    this.ref.close(obj);
  }

  ngOnInit() {
    this.consultarSugestaoLotes();
    console.log(this.infoCTE);
  }

  consultarSugestaoLotes() {
    this.isLoading = true;
    if (this.infoCTE) {
      this.service.consultarSugestaoLotes(this.infoCTE).subscribe(
        (response: sugestaoLotesResponse) => {
          if (response) {
            console.log('sugestao lotes', response);
            this.gridLoteGeral.data = [response.loteGeral]
            this.gridLotesPorCliente.data = response.lotesPorCliente
            this.totalCte = response.loteGeral.qtdItens;
          }
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoading = false;
          this.openSnackBar(`Erro ao obter sugestão lotes, entre em contato com o suporte : ` + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        }).add(() => this.isLoading = false);
    }
  }


  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
